export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_SIRE_3.60b93b9e.jpg";